import { AUTH_ROUTE_PATHS } from "./authRouteConfig";

const toInAppPath = (url) => {
  const parsedUrl = new URL(url, globalThis.location.origin);
  if (parsedUrl.origin !== globalThis.location.origin) {
    return null;
  }

  return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};

// Centralizes redirect decisions: prefer router navigation for same-origin URLs
// and fall back to full reload only when crossing origins.
export const navigateToUrl = ({ url, navigate, replace = false }) => {
  if (!url) {
    return false;
  }

  try {
    const inAppPath = toInAppPath(url);
    if (inAppPath && navigate) {
      navigate(inAppPath, { replace });
      return true;
    }

    // OIDC/external boundaries still require hard redirect behavior.
    globalThis.location.href = new URL(
      url,
      globalThis.location.origin,
    ).toString();
    return true;
  } catch (error) {
    console.warn("Invalid navigation URL blocked.", error);
    return false;
  }
};

export const navigateToAuthCheck = (navigate, replace = true) => {
  if (!navigate) {
    return false;
  }

  navigate(AUTH_ROUTE_PATHS.AUTH_CHECK, { replace });
  return true;
};
